import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const TeamSection = () => {
  const [showAdvisors, setShowAdvisors] = useState(false);

  const team = [
    {
      name: 'Arunachalam Saravanan',
      role: 'Founder & CEO',
      image: 'https://customer-assets.emergentagent.com/job_nura-website-copy/artifacts/swf5bnse_Arun.jpeg',
    },
    {
      name: 'Raghunandana Tangirala',
      role: 'Investor / Advisor',
      image: 'https://customer-assets.emergentagent.com/job_nurae-electric/artifacts/n5f6z9eu_cofounder.jpg',
    },
    {
      name: 'Ashok Kumar',
      role: 'Business Head',
      image: 'https://customer-assets.emergentagent.com/job_evmobility-clone/artifacts/0jumfnt1_ashok%20%282%29.jpeg',
    },
    {
      name: 'Sarma T',
      role: 'CTO',
      image: 'https://customer-assets.emergentagent.com/job_nura-website-copy/artifacts/m9kt6e4k_CTO.jpeg',
    },
  ];

  const advisors = [
    {
      name: 'RD Saravanan',
      role: 'Chairman - RDS group of companies',
      company: '',
      image: 'https://customer-assets.emergentagent.com/job_nura-website-copy/artifacts/0u7r8feu_RD%20Saravanan%20%282%29.jpeg',
    },
    {
      name: 'Sampath GV',
      role: 'Chairman - Naruvi Hospitals',
      company: '',
      image: 'https://customer-assets.emergentagent.com/job_nura-website-copy/artifacts/mdk196nu_Sampath.jpeg',
    },
    {
      name: 'Ganesh Radhakrishnan',
      role: 'Founder & CEO, FEKKI.io',
      company: '',
      image: 'https://customer-assets.emergentagent.com/job_nura-website-copy/artifacts/stdyv08g_Ganesh.jpeg',
    },
    {
      name: 'Shankar A',
      role: 'Head - Government Solutions',
      company: 'JLL India',
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/pzllwcyd_shankar%20%282%29.jpeg',
    },
  ];

  return (
    <section id="team" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 px-4">
            Meet the people <span className="text-[#bceb39]">revolutionizing auto rides!</span>
          </h2>
        </div>

        {/* Team Section - Responsive: 1 col on mobile, 2 on tablet, 4 on desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 max-w-7xl mx-auto mb-16 sm:mb-20">
          {team.map((member, index) => (
            <div
              key={index}
              className="text-center transform hover:-translate-y-2 transition-all duration-300"
            >
              <div className="mb-6">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-40 h-40 sm:w-48 sm:h-48 mx-auto rounded-full object-cover shadow-lg grayscale hover:grayscale-0 transition-all duration-300"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2">{member.name}</h3>
              <p className="text-base sm:text-lg text-gray-600">{member.role}</p>
            </div>
          ))}
        </div>

        {/* Board of Advisors Section - Expandable like FAQs */}
        <div className="mt-16 sm:mt-20">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-4xl mx-auto">
              <button
                onClick={() => setShowAdvisors(!showAdvisors)}
                className="w-full bg-gray-100 hover:bg-gray-200 rounded-2xl p-6 sm:p-8 flex items-center justify-center gap-4 transition-all duration-300 shadow-md hover:shadow-lg"
              >
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center">
                  Board of Advisors
                </h3>
                {showAdvisors ? (
                  <ChevronUp size={28} className="text-gray-600 flex-shrink-0" />
                ) : (
                  <ChevronDown size={28} className="text-gray-600 flex-shrink-0" />
                )}
              </button>
            </div>

            {/* Expandable Content */}
            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${
                showAdvisors ? 'max-h-[2000px] opacity-100 mt-12' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
                {advisors.map((advisor, index) => (
                  <div
                    key={index}
                    className="text-center transform hover:-translate-y-2 transition-all duration-300"
                  >
                    <div className="mb-6">
                      <img
                        src={advisor.image}
                        alt={advisor.name}
                        className="w-40 h-40 sm:w-48 sm:h-48 mx-auto rounded-full object-cover shadow-lg grayscale hover:grayscale-0 transition-all duration-300"
                      />
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold mb-2">{advisor.name}</h3>
                    <p className="text-base sm:text-lg text-gray-600">{advisor.role}</p>
                    {advisor.company && (
                      <p className="text-sm sm:text-md text-gray-500">{advisor.company}</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;